<template>
  <div>
    <w-radio-list class="form-group" :model="model.type" :values="employerTypes" />

    <person :model="model">
      <div class="row form-group">
        <div class="col-6">
          <w-input :model="model.workplaceName" />
        </div>

        <div class="col-6">
          <w-input :model="model.nip" />
        </div>
      </div>

      <template v-if="!model.representative.$disabled">
        <p class="label">{{ model.representative.$title }}</p>

        <w-radio-list class="form-group" :model="model.representative.gender" :values="gender" />

        <w-radio-list class="form-group" :model="model.representative.type" :values="representationTypes" />

        <div class="row form-group">
          <div class="col-6">
            <w-input :model="model.representative.firstName" />
          </div>

          <div class="col-6">
            <w-input :model="model.representative.lastName" />
          </div>
        </div>
      </template>

      <slot name="accept-statement">
        <div v-if="model.$parent.acceptStatements" class="row form-group mt-2">
          <div class="col-12">
            <yes-or-no-radio class="mt-2" :model="model.$parent.acceptStatements" />
          </div>
        </div>
      </slot>

      <div class="row form-group mt-2">
        <div v-if="model.bankAccount" class="col-6">
          <w-input :model="model.bankAccount" mask="XX XXXX XXXX XXXX XXXX XXXX XXXX" />
        </div>

        <div class="col-6">
          <w-input :model="model.phoneNumber" />
        </div>
      </div>
    </person>

    <slot name="artisan" />

    <partners :model="model.partners" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { GENDER } from '@/utils/constants';

import Partners from './Partners.vue';
import Person from './Person.vue';
import YesOrNoRadio from './YesOrNoRadio.vue';

// @vuese
// Formularz wnioskodawcy-pracodawcy
export default {
  components: {
    Partners,
    Person,
    YesOrNoRadio,
    ...components
  },
  props: {
    // Model wnioskodawcy-pracodawcy
    model: { type: Object, required: true }
  },
  data() {
    return {
      gender: GENDER,
      employerTypes: [
        { value: 1, text: 'Osoba fizyczna' },
        { value: 2, text: 'Osoba prawna' },
        { value: 3, text: 'Spółka cywilna' }
      ],
      representationTypes: [
        { value: 1, text: 'Prezes' },
        { value: 2, text: 'Prezes Zarządu' }
      ]
    };
  }
};
</script>

<style>
.hide-label label {
  display: none;
}

.solid-border-top td {
  border-top: 3px solid black;
}
</style>
